import { LitElement, html } from 'lit';
import typographyStyles from '@cof/fs-typography-core/lib/typography.lit.js';
import { TagKey } from '@cof/tag-catalog-fs-personal-mfe';
import { DebugService } from '../../../../shared/services/debug.service.js';
import { ApplicationService } from '../../../../services/application.service.js';
import { style } from './employment-active-toggle-v2.style.js';
import { globalStyle } from '../../../../global-styles.style.js';
import { REFI_PERSONAL_CONST } from '../../../../shared/constants/app.constants.js';
import { stratum } from '../../../../../constants/stratum.js';

class RefiPersonalEmploymentActiveToggleComponent extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiStepEmploymentActiveToggle');
    this.applicant = {};
    this.active = false;
    this.employmentActiveMissing = true;
    this.isIconic = false;
    this.isPrefill = false;
    this.values = {};
    this.isPrimary = false;
  }

  static styles = [style, globalStyle, typographyStyles];

  static properties = {
    application: { type: Object, reflect: true },
    applicant: { type: Object, reflect: true },
    isPrimary: { type: Boolean, attribute: 'is-primary', reflect: true },
    employmentActiveMissing: { type: Boolean, reflect: true },
    isPrefill: { type: Boolean, attribute: 'is-prefill' },
  };

  connectedCallback() {
    super.connectedCallback();
    this.resetValues();

    this.employmentActiveMissing = !this.values.activeIncomeVerification;
  }

  resetValues() {
    this.application = ApplicationService.Application;
    this.applicant = this.isPrimary
      ? this.application.primaryApplicant
      : this.application.coApplicant;
    this.coAppPrefix = this.isPrimary ? '' : 'co-';

    this.values = {
      activeIncomeVerification:
        this.applicant.employmentInfo.activeIncomeVerification,
    };

    this.debug.log('Resetting values', this.values);

    // Ensure DOM is settled before grabbing the element
    setTimeout(() => {
      const radioYes = this.shadowRoot.getElementById(
        `${this.coAppPrefix}toggleEmploymentActiveYes`
      );
      const radioNo = this.shadowRoot.getElementById(
        `${this.coAppPrefix}toggleEmploymentActiveNo`
      );
      if (this.values.activeIncomeVerification === 'Yes') {
        radioYes.checked = true;
      } else if (this.values.activeIncomeVerification === 'No') {
        radioNo.checked = true;
      }

      this.dispatchEvent(
        new CustomEvent('validity', {
          detail: {
            name: `activeIncomeVerification`,
            isValid: !!this.values.activeIncomeVerification,
          },
        })
      );
    }, 0);
    this.requestUpdate();
  }

  render() {
    const className =
      this.isPrimary &&
      (!this.applicant.employmentStatus ||
        !this.applicant.employmentInfo.jobDescription)
        ? 'primary-active-income-prefilled'
        : 'co-active-income-prefilled';
    return html`
      <div
        class="${className}"
        role="radiogroup"
        aria-labelledby="toggleEmploymentActiveHeader"
      >
        <fs-heading
          level="2"
          size="small"
          variant="primary"
          id="toggleEmploymentActiveHeader"
        >
          Are ${this.isPrimary ? 'you' : 'they'} currently earning income from
          this job?
        </fs-heading>
      </div>
      <div class="${this.isPrimary ? '' : 'co-radio-group'}">
        <fs-radio
          id="${this.coAppPrefix}toggleEmploymentActiveYes"
          name="toggleEmploymentActive"
          value="${REFI_PERSONAL_CONST.ACTIVE_INCOME_VERIFICATION_TYPE.yes}"
          ?checked="${this.values.activeIncomeVerification ===
          REFI_PERSONAL_CONST.ACTIVE_INCOME_VERIFICATION_TYPE.yes}"
          @change="${this.employmentActiveChange}"
          >Yes
        </fs-radio>
        <fs-radio
          id="${this.coAppPrefix}toggleEmploymentActiveNo"
          name="toggleEmploymentActive"
          value="${REFI_PERSONAL_CONST.ACTIVE_INCOME_VERIFICATION_TYPE.no}"
          ?checked="${this.values.activeIncomeVerification ===
          REFI_PERSONAL_CONST.ACTIVE_INCOME_VERIFICATION_TYPE.no}"
          @change="${this.employmentActiveChange}"
          >No, it’s paused or just ended
        </fs-radio>
      </div>
    `;
  }

  firstUpdated() {
    // check if value is already set
    if (this.applicant.employmentInfo.activeIncomeVerification) {
      this.dispatchEvent(
        new CustomEvent('validity', {
          detail: {
            name: `activeIncomeVerification`,
            isValid: true,
          },
        })
      );
    } else {
      this.dispatchEvent(
        new CustomEvent('validity', {
          detail: {
            name: `activeIncomeVerification`,
            isValid: false,
          },
        })
      );
    }
  }

  employmentActiveChange(ev) {
    this.values.activeIncomeVerification = ev.target.value;
    stratum.publishTag(TagKey.PQ_TEXT_INPUT_FIELD_EDITED_FIELD, {
      replacements: {
        value: `${this.isPrimary ? '' : 'co-'}activeIncomeVerification`,
      },
    });
    this.dispatchEvent(
      new CustomEvent('validity', {
        detail: {
          name: `activeIncomeVerification`,
          isValid: true,
        },
      })
    );
  }

  saveToApplication() {
    this.applicant.employmentInfo.activeIncomeVerification =
      this.values.activeIncomeVerification;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.dispatchEvent(
      new CustomEvent('validity', {
        detail: {
          name: `activeIncomeVerification`,
          isValid: true,
        },
      })
    );
  }
}

customElements.define(
  'refi-personal-employment-active-toggle-v2',
  RefiPersonalEmploymentActiveToggleComponent
);
